import { request, setStoredToken, clearStoredToken, setCurrentTenantId, setCurrentEnterpriseId } from './client';

/** Public login lookup; never send a previous account's token or tenant headers. */
export const searchLoginTenants = async (keyword) => {
  const query = String(keyword || '').trim();
  if (query.length < 2) throw new Error('请输入至少2个字符进行搜索');
  const result = await request('/api/label/tenant/search', {
    params: { keyword: query }, skipBaseUrl: true, skipAuth: true, skipTenant: true,
  });
  return Array.isArray(result?.list) ? result.list : [];
};

/**
 * 用户登录
 * @param {Object} credentials - {username, password, tenantId?}
 */
export const login = async (credentials) => {
  const user = await request('/auth/login', {
    method: 'POST',
    body: credentials,
    skipAuth: true,
    skipTenant: true,
  });
  // 后端返回的是用户对象，token在user.token中
  if (user?.token) {
    // Commit context only after the backend has validated tenant membership.
    setCurrentTenantId(user.tenantId ?? credentials.tenantId ?? null);
    setCurrentEnterpriseId(user.enterpriseId ?? null);
    setStoredToken(user.token);
  } else {
    throw new Error('登录响应缺少凭证，请重新登录');
  }
  return user;
};

/**
 * 用户注册
 * @param {Object} payload - 注册信息
 */
export const register = async (payload) => {
  return request('/auth/register', {
    method: 'POST',
    body: payload,
    skipAuth: true,
  });
};

/**
 * 发送验证码
 * @param {Object} params - {phone, codeType}
 * 注意：后端使用@RequestParam接收，POST请求会将参数放在URL查询字符串中
 */
export const sendVerifyCode = async ({ phone, codeType }) => {
  return request('/auth/send-code', {
    method: 'POST',
    params: { phone, codeType },
    skipAuth: true,
  });
};

/**
 * 获取当前用户信息
 */
export const fetchCurrentUser = async () => {
  return request('/auth/info', {
    method: 'GET',
  });
};

/**
 * 用户登出
 */
export const logout = async () => {
  try {
    await request('/auth/logout', {
      method: 'POST',
    });
  } finally {
    clearStoredToken();
    setCurrentTenantId(null);
    setCurrentEnterpriseId(null);
  }
};
